import usersCreateUserRedux from 'Modules/pmUsers/.components/createEditUser/redux/reducer';
import usersDeleteUserRedux from 'Modules/pmUsers/.components/deleteUser/redux/reducer';
import usersResetPasswordUserRedux from 'Modules/pmUsers/.components/resetPassword/redux/reducer';
import jiraSummaryRedux from 'Modules/pmUsers/views/jiraSummary/redux/reducer';
import forceLogoutRedux from 'Modules/pmUsers/.components/forceLogout/redux/reducer';
import userDetailsRedux from 'Modules/pmUsers/views/jiraSummary/.components/userDetails/redux/reducer';
//export redux objects
export default {
	usersCreateUserRedux,
	usersDeleteUserRedux,
	usersResetPasswordUserRedux,
	jiraSummaryRedux,
	forceLogoutRedux,
	userDetailsRedux,
};